import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Expo, TimelineLite, TweenLite} from "gsap";
import {TeslaTextStyles} from "../../../../config/TeslaTextStyles";

/**
 * Created by h3 on 2017-10-04.
 */

export class CountUpComponent extends PIXI.Container {

    private _countUpAmount:PIXI.BitmapText;
    private _currentDisplayAmount:number;


    constructor() {
        super();
        this.initAnimations();
    }

    protected initAnimations():void {
        this._currentDisplayAmount = 0;
        this.createCountUp();

    }

    private createCountUp() {
        this._countUpAmount = new PIXI.BitmapText(Currency.formatValue(0),TeslaTextStyles.COUNT_UP_TEXTSTYLE_BIG );
        this._countUpAmount.alpha = 0;
        this._countUpAmount.pivot.x = this._countUpAmount.textWidth * 0.5;
        this._countUpAmount.pivot.y = this._countUpAmount.textHeight * 0.5;
        this._countUpAmount.scale.set(1, 1);
        this.addChild(this._countUpAmount);
    }

    private updateWinText() {
        let newString = Currency.formatValue(this._currentDisplayAmount);
        if(newString.length != this._countUpAmount.text.length) {
            this._countUpAmount.text = newString;
            this._countUpAmount.pivot.x = this._countUpAmount.textWidth * 0.5;
            this._countUpAmount.pivot.y = this._countUpAmount.textHeight * 0.5;

            this._countUpAmount.updateTransform();

        } else {
            this._countUpAmount.text = newString
        }

    }

    private centerWinText() {
        this._countUpAmount.pivot.x = this._countUpAmount.textWidth * 0.5;
        this._countUpAmount.pivot.y = this._countUpAmount.textHeight * 0.5;
    }

    public getCountUpTimeline(winLevel:number, countUpValues:[number, number][]) {
        this._countUpAmount.alpha = 1;
        const tl:TimelineLite = new TimelineLite();
        let duration = 3;

        if(winLevel > 0) {

            tl.add([
                TweenLite.fromTo(this, duration,
                    {_currentDisplayAmount : countUpValues[winLevel - 1][1]},
                    {
                        _currentDisplayAmount : countUpValues[winLevel][1],
                        onUpdate : () => this.updateWinText(),
                        ease : Expo.easeOut
                    }
                ),
                () => new TweenLite(this._countUpAmount.scale, 0.2, {
                    x : 1 + winLevel * 0.1,
                    y : 1 + winLevel * 0.1
                })
            ], 0);
            tl.add(() => this.centerWinText());
        } else {
            tl.add(TweenLite.fromTo(this, duration,
                {_currentDisplayAmount : countUpValues[winLevel][0]},
                {
                    _currentDisplayAmount : countUpValues[winLevel][1],
                    onUpdate : () => this.updateWinText(),
                    ease : Expo.easeOut
                }
            ), 0);
            tl.add(() => this.centerWinText());

        }


        return tl;
    }

    public resetCountUp() {
        this._countUpAmount.alpha = 0;
        this._countUpAmount.scale.set(1, 1);
    }

}